import api from "./api";

class ValutaManager {
    valute(config?: any) {
        return api.get(`/valute`, config)
    }
    valuta(id: number | string) {
        return api.get(`/valute/${id}`)

    }
    list = this.valute
    retrieve = this.valuta
}

const valutaManager = new ValutaManager()

export default valutaManager
